import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { expertTipApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ExpertTipStatus } from '../types/expert-tip';

interface UpdateStatusVariables {
  id: string;
  status: ExpertTipStatus;
}

export function useUpdateExpertTipStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: UpdateStatusVariables) =>
      expertTipApi.updateExpertTipStatus(variables.id, variables.status),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.expertTips.detail(variables.id),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.expertTips.lists() });


      const messageMap: Record<ExpertTipStatus, string> = {
        published: 'Expert tip published successfully',
        unpublished: 'Expert tip unpublished successfully',
        archived: 'Expert tip archived successfully',
      };
      toast.success(messageMap[variables.status]);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update expert tip status');
    },
  });
}
